import { Component, OnInit } from '@angular/core';
import { Employee } from 'app/vouchers/Models/employee';
import { Router } from '@angular/router';
import { EProvider } from 'app/vouchers/Shared/enum/provider.enum';
import { ArkiaProvider, IsrairProvider } from 'app/vouchers/Shared/constants';
import { UserMessagesService } from 'app/shared/user-messages/user-messages.service';

@Component({
  selector: 'app-main-order',
  templateUrl: './main-order.component.html',
  styleUrls: ['./main-order.component.css']
})




export class MainOrderComponent implements OnInit {
  
  

  employee:Employee = new Employee();
  selectedProviderToSessioStorage: number;
  constructor(private _router:Router,
              private _userMessages : UserMessagesService) { }

  ngOnInit(): void {
    this._userMessages.clearAll();
    //get the employee's usedbenefits from server.
    
  }

  selectedProvider(event)
  {
    debugger;
    let selectedProviderEvent:string = event.target.id;
    if(selectedProviderEvent == ArkiaProvider)
    {
      this.selectedProviderToSessioStorage = EProvider.arkia;
    }
    else if(selectedProviderEvent == IsrairProvider)
    this.selectedProviderToSessioStorage = EProvider.israir;
    else
    this.selectedProviderToSessioStorage = EProvider.none;     

    this.employee.selectedProvider =  this.selectedProviderToSessioStorage;
    sessionStorage.setItem('employee',JSON.stringify(this.employee));
    this._router.navigateByUrl('/vouchers/vouchers-order-details');
  }
}
